module.exports = __webpack_public_path__ + "img/check-y.03585cdd.png";